export default "__VITE_ASSET__C8fxH06a__"